import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  //pipe for unsafe external urls for use in iframes
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
